/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ask-teacher-button[_ngcontent-%COMP%]{color:#ff6000!important;cursor:pointer}"];
export { styles as styles };
//# sourceMappingURL=ask-teacher-button.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/contact-us/ask-teacher-button/ask-teacher-button.component.scss.shim.ngstyle.js
// module id = 1647
// module chunks = 26 27 28